/*istanbul ignore file*/
import StackdriverErrorReporter from 'stackdriver-errors-js';
import {APP_VERSION} from "constants.js";
const errorHandler = new StackdriverErrorReporter();
export const startErrorHandler = () => {
    errorHandler.start({
        key: 'AIzaSyCmDjFnamTJOsCMDzE-rroFo3QunHvEcrg',
        projectId: 'osa-prod',
        version: APP_VERSION,
        service: "osa-webapp",
        disabled: process.env.NODE_ENV === "development"
    });
}
export default errorHandler;